<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;900"
      type="text/css">
<link href="https://fonts.googleapis.com/css2?family=Fira+Sans:wght@100;200;300;400;500;700&display=swap"
      rel="stylesheet">
<ngx-loading [show]="loading"></ngx-loading>
<ng-container *ngIf="!loading">
  <ng-container *ngIf="orderNotProcessed; else orderProcessed">

    <div class="d-flex flex-column min-vh-100 shadow">
      <!-- page content -->
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <div class="text-center p-4">

          <div class="logo mb-5">
            <img class="col-12" src="/assets/img/primary-logo.svg" />
          </div>

          <div class="d-flex justify-content-center my-4">
            <svg width="85" height="73" viewBox="0 0 85 73" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M83.5621 62.7344L48.5664 3.42188C45.8871 -1.14062 39.1259 -1.14062 36.4286 3.42188L1.44919 62.7344C-1.24317 67.2806 2.11023 73 7.5066 73H77.4982C82.8731 73 86.2365 67.2969 83.5621 62.7344ZM38.5582 22.1607C38.5582 20.0017 40.3219 18.25 42.4958 18.25C44.6697 18.25 46.4335 20.0098 46.4335 22.1607V43.0179C46.4335 45.1769 44.6697 46.9286 42.6435 46.9286C40.6172 46.9286 38.5582 45.185 38.5582 43.0179V22.1607ZM42.4958 62.5714C39.6476 62.5714 37.3375 60.2771 37.3375 57.4484C37.3375 54.6196 39.646 52.3254 42.4958 52.3254C45.3457 52.3254 47.6541 54.6196 47.6541 57.4484C47.6476 60.2739 45.3506 62.5714 42.4958 62.5714Z"
                fill="#FFA500" />
            </svg>
          </div>

          <div class="h4 font-weight-bold">
            Your receipt is being processed.
          </div>

          <div class="p font-weight-bold">
            Please try again in 30 seconds
          </div>

        </div>
      </div>

    </div>

  </ng-container>
  <ng-template #orderProcessed>
    <div class="card shadow border-0 receipt min-vh-100 pt-2" id="pdf-content"
       *ngIf="processedConfiguration$ | async as config">

    <div [@cardAnimation]="notificationAnimationState">
      <div class="d-flex align-items-center mt-4 receipt-sent">
        <!-- Check Icon -->
        <div class="">
          <svg class="check-icon" width="28" height="28" viewBox="0 0 20 20" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 10C0 4.47656 4.47656 0 10 0C15.5234 0 20 4.47656 20 10C20 15.5234 15.5234 20 10 20C4.47656 20 0 15.5234 0 10ZM14.5234 8.27344C14.9492 7.84766 14.9492 7.15234 14.5234 6.72656C14.0977 6.30078 13.4023 6.30078 12.9766 6.72656L8.75 10.9531L7.02344 9.22656C6.59766 8.80078 5.90234 8.80078 5.47656 9.22656C5.05078 9.65234 5.05078 10.3477 5.47656 10.7734L7.97656 13.2734C8.40234 13.6992 9.09766 13.6992 9.52344 13.2734L14.5234 8.27344Z"
              fill="#00CB44"/>
          </svg>
        </div>

        <!-- Text Content -->
        <div class="flex-grow-1">
          <div class="receipt-text ml-2">
            Receipt sent to<br>
            <span class="email-text">{{ emailAddress }}</span>
          </div>
        </div>

        <!-- Close Button -->
        <button class="close" (click)="toggleReceiptSentNotification()" style="outline: none;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>

    <div *ngIf="config.customerEngagement.customerRegistration && config.customerEngagement.addIncentiveToRegister"
         class="registration-container">
      <p *ngIf="config.customerEngagement.registerIncentive" class="subtitle">REGISTER AND
        GET {{ config.customerEngagement.registerIncentive?.toUpperCase() }}</p>

      <div class="social-login d-flex justify-content-between">
        <a class="social-btn shadow">
          <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19.7798 18.424C19.432 19.2275 19.0203 19.9672 18.5433 20.6472C17.893 21.5743 17.3606 22.216 16.9503 22.5724C16.3143 23.1573 15.6329 23.4568 14.9031 23.4739C14.3792 23.4739 13.7475 23.3248 13.0121 23.0224C12.2742 22.7214 11.5962 22.5724 10.9762 22.5724C10.326 22.5724 9.62861 22.7214 8.8827 23.0224C8.13565 23.3248 7.53383 23.4824 7.0737 23.498C6.37393 23.5278 5.67643 23.2197 4.9802 22.5724C4.53583 22.1848 3.98002 21.5204 3.31417 20.5791C2.59977 19.5739 2.01244 18.4084 1.55231 17.0795C1.05953 15.6442 0.8125 14.2543 0.8125 12.9087C0.8125 11.3673 1.14556 10.0379 1.81269 8.92385C2.33698 8.029 3.03449 7.32312 3.90747 6.80493C4.78045 6.28674 5.7237 6.02267 6.73951 6.00578C7.29532 6.00578 8.0242 6.1777 8.92998 6.51559C9.83319 6.85462 10.4131 7.02655 10.6674 7.02655C10.8575 7.02655 11.5018 6.82552 12.594 6.42473C13.6268 6.05305 14.4985 5.89916 15.2126 5.95978C17.1477 6.11595 18.6015 6.87876 19.5683 8.25303C17.8377 9.30163 16.9816 10.7703 16.9986 12.6544C17.0142 14.122 17.5466 15.3432 18.5929 16.3129C19.0671 16.7629 19.5967 17.1107 20.1859 17.3578C20.0581 17.7283 19.9232 18.0832 19.7798 18.424ZM15.3418 0.960131C15.3418 2.11039 14.9216 3.18439 14.0839 4.17847C13.0731 5.36023 11.8505 6.04311 10.5246 5.93536C10.5077 5.79736 10.4979 5.65213 10.4979 5.49951C10.4979 4.39526 10.9786 3.21349 11.8323 2.24724C12.2585 1.75801 12.8005 1.35122 13.4579 1.02671C14.1138 0.707053 14.7342 0.530273 15.3177 0.5C15.3347 0.653772 15.3418 0.807554 15.3418 0.960116V0.960131Z"
              fill="black"/>
          </svg>
        </a>

        <a class="social-btn shadow">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" transform="translate(0.5)" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M23.54 12.2605C23.54 11.445 23.4668 10.6609 23.3309 9.9082H12.5V14.3566H18.6891C18.4225 15.7941 17.6123 17.0121 16.3943 17.8275V20.713H20.1109C22.2855 18.7109 23.54 15.7627 23.54 12.2605Z"
                  fill="#4285F4"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.4995 23.5005C15.6045 23.5005 18.2077 22.4708 20.1104 20.7144L16.3938 17.829C15.364 18.519 14.0467 18.9267 12.4995 18.9267C9.50425 18.9267 6.96902 16.9037 6.0647 14.1855H2.22266V17.1651C4.11493 20.9235 8.00402 23.5005 12.4995 23.5005Z"
                  fill="#34A853"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.06523 14.1855C5.83523 13.4955 5.70455 12.7584 5.70455 12.0005C5.70455 11.2425 5.83523 10.5055 6.06523 9.81548V6.83594H2.22318C1.44432 8.38844 1 10.1448 1 12.0005C1 13.8562 1.44432 15.6125 2.22318 17.165L6.06523 14.1855Z"
                  fill="#FBBC05"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.4995 5.07386C14.1879 5.07386 15.7038 5.65409 16.8956 6.79364L20.194 3.49523C18.2024 1.63955 15.5992 0.5 12.4995 0.5C8.00402 0.5 4.11493 3.07705 2.22266 6.83545L6.0647 9.815C6.96902 7.09682 9.50425 5.07386 12.4995 5.07386Z"
                  fill="#EA4335"/>
          </svg>
        </a>

        <a class="social-btn shadow">
          <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M23 12.0713C23 5.72007 17.8513 0.571344 11.5 0.571344C5.14872 0.571344 0 5.72007 0 12.0713C0 17.8113 4.20538 22.5689 9.70312 23.4316V15.3956H6.7832V12.0713H9.70312V9.53775C9.70312 6.65556 11.42 5.06353 14.0468 5.06353C15.305 5.06353 16.6211 5.28814 16.6211 5.28814V8.11822H15.171C13.7424 8.11822 13.2969 9.00468 13.2969 9.91413V12.0713H16.4863L15.9765 15.3956H13.2969V23.4316C18.7946 22.5689 23 17.8113 23 12.0713Z"
              fill="#1877F2"/>
          </svg>
        </a>
      </div>

      <div class="divider">
        <span>or use phone / email</span>
      </div>

      <button class="btn btn-dark dark-button d-flex align-items-center justify-content-center mb-3 w-100">Register
      </button>

      <div class="login-link">
        Already have an account? <a>Login here</a>
      </div>
    </div>

    <div data-html2canvas-ignore="true" [@cardAnimation]="employeeAnimationState">

      <div *ngIf="config.salesPersonDetails.salesPersonDetails" class="card custom-card shadow-sm">
        <div class="card-body mb-0 p-2">
          <div class="d-flex align-items-start">
            <img [src]="config.salesPersonDetails.defaultSalesPersonImage ?? '/assets/img/sales-person-image.png'"
                 class="rounded-circle mr-3 profile-image"
                 alt="Profile picture of Server">

            <div class="flex-grow-1">
              <div class="user-name">Aisling</div>
              <div
                class="user-message pr-4">{{ config.salesPersonDetails.defaultSalesPersonMessage ?? 'It was my pleasure to assist you today!' }}
              </div>
            </div>

            <button class="close" (click)="toggleEmployeeSection()" style="outline: none;">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>

        <div *ngIf="config.salesPersonDetails.showSalesPersonRating" class="mb-2 align-self-center" style="width: 250px;">
          <star-rating [starType]="'svg'" [rating]="employeeRating" [size]="'large'" [hoverEnabled]="'true'"
                       [speed]="'noticeable'" [space]="'between'"
                       (starClickChange)="onStarClicked($event)">
          </star-rating>
        </div>

        <div *ngIf="config.salesPersonDetails.leaveTip && showLeaveTip && !showTipOptions" (click)="leaveTip()"
             class="btn btn-dark dark-button d-flex align-items-center justify-content-center mx-3 mb-3 mt-2 fade-in">
          Leave Tip
        </div>
        <div *ngIf="showTipOptions" [@slideDown] class="mx-2">
          <div class="ont-weight-bold h5 ml-4">Tip Amount</div>
          <button class="card tip-card mb-2 p-0 btn btn-block" (click)="tipSelected(order?.totalPrice * 0.10)">
            <div class="card-body py-3 px-4 m-0">
              <div class="d-flex justify-content-between align-items-center">
                <span class="font-weight-normal">10% - Good Service</span>
                <span class="font-weight-bold h5 mb-0">€{{ getRoundedTip(0.10) | number:'1.2-2' }}</span>
              </div>
            </div>
          </button>
          <button class="card tip-card mb-2 p-0 btn btn-block" (click)="tipSelected(order?.totalPrice * 0.15)">
            <div class="card-body py-3 px-4 m-0">
              <div class="d-flex justify-content-between align-items-center">
                <span class="font-weight-normal">15% - Great Service</span>
                <span class="font-weight-bold h5 mb-0">€{{ getRoundedTip(0.15) | number:'1.2-2' }}</span>
              </div>
            </div>
          </button>
          <button class="card tip-card mb-2 p-0 btn btn-block" (click)="tipSelected(order?.totalPrice * 0.20)">
            <div class="card-body py-3 px-4 m-0">
              <div class="d-flex justify-content-between align-items-center">
                <span class="font-weight-normal">20% - Best Service Ever!</span>
                <span class="font-weight-bold h5 mb-0">€{{ getRoundedTip(0.20) | number:'1.2-2' }}</span>
              </div>
            </div>
          </button>
          <ng-select
            #customAmountSelect
            appendTo="body"
            placeholder="Other Amount"
            [items]="amountOptions"
            [(ngModel)]="customTipAmount"
            (ngModelChange)="customTipSelected($event)"
            bindLabel="label"
            bindValue="value"
            [addTag]="true"
            [addTagText]="'Add custom amount: €'"
            [clearable]="false"
            class="card tip-card mb-2 p-0 btn btn-block custom-amount-ng-select font-weight-bold"
          >
          </ng-select>

          <div *ngIf="selectedTipAmount" class="payment-container">
            <h5 class="payment-title ml-2 mb-1">Payment</h5>

            <!-- Apple Pay Button -->
            <button class="btn apple-pay-btn" type="button">
              Pay with
              <svg width="55" height="23" viewBox="0 0 55 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.7479 4.82764C9.41143 4.82764 8.33331 5.63623 7.63702 5.63623C6.90704 5.63623 5.92999 4.87256 4.77325 4.87256C2.57207 4.87256 0.337212 6.70312 0.337212 10.1284C0.337212 12.2734 1.16827 14.5308 2.19024 16.002C3.05499 17.2261 3.82989 18.2368 4.93047 18.2368C6.01983 18.2368 6.50274 17.5181 7.86163 17.5181C9.23174 17.5181 9.5462 18.2144 10.7479 18.2144C11.9495 18.2144 12.7469 17.125 13.4993 16.0469C14.3304 14.8003 14.6898 13.5874 14.701 13.5312C14.6336 13.5088 12.3426 12.5767 12.3426 9.94873C12.3426 7.68018 14.1395 6.66943 14.2405 6.59082C13.0613 4.87256 11.2532 4.82764 10.7479 4.82764ZM10.1302 3.37891C10.6692 2.71631 11.0511 1.81787 11.0511 0.908203C11.0511 0.784668 11.0398 0.661133 11.0174 0.560059C10.1414 0.59375 9.06329 1.14404 8.42315 1.89648C7.92901 2.46924 7.45733 3.37891 7.45733 4.28857C7.45733 4.42334 7.47979 4.56934 7.49102 4.61426C7.54717 4.62549 7.63702 4.63672 7.72686 4.63672C8.52422 4.63672 9.53497 4.09766 10.1302 3.37891ZM19.1155 1.8291V18.0347H22.013V12.7227H25.5281C28.8074 12.7227 31.0984 10.5215 31.0984 7.30957C31.0984 4.0415 28.886 1.8291 25.6516 1.8291H19.1155ZM22.013 4.25488H24.888C26.9768 4.25488 28.156 5.32178 28.156 7.30957C28.156 9.24121 26.9431 10.3193 24.8767 10.3193H22.013V4.25488ZM36.5349 16.0469C35.2995 16.0469 34.4123 15.4292 34.4123 14.396C34.4123 13.3965 35.1423 12.835 36.7033 12.7339L39.4773 12.5542V13.5312C39.4773 14.9575 38.2195 16.0469 36.5349 16.0469ZM35.7151 18.2368C37.321 18.2368 38.6687 17.5405 39.3537 16.3501H39.5447V18.0347H42.2287V9.64551C42.2287 7.04004 40.4543 5.50146 37.2986 5.50146C34.3786 5.50146 32.3459 6.88281 32.1213 9.05029H34.7492C35.0075 8.21924 35.8835 7.77002 37.1638 7.77002C38.6687 7.77002 39.4773 8.44385 39.4773 9.64551V10.6787L36.3103 10.8696C33.323 11.0493 31.6496 12.3296 31.6496 14.5532C31.6496 16.7993 33.3454 18.2368 35.7151 18.2368ZM45.3293 22.4932C48.0808 22.4932 49.3947 21.4824 50.4392 18.4277L54.8752 5.74854H51.9328L49.069 15.3394H48.8781L46.0031 5.74854H42.9484L47.3395 18.0908L47.1935 18.6299C46.8342 19.7642 46.1716 20.2134 44.9924 20.2134C44.8015 20.2134 44.3859 20.2021 44.2287 20.1685V22.4482C44.4084 22.4819 45.1608 22.4932 45.3293 22.4932Z"
                  fill="white"/>
              </svg>
            </button>

            <!-- Divider -->
            <div class="divider">
              <span>or</span>
            </div>

            <!-- Card Details Header -->
            <div class="card-details-header mx-3 mb-1">
              <span>Card details</span>
              <div class="payment-icons">
                <svg width="76" height="17" viewBox="0 0 76 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.3738 2.21143H9.66333V14.7886H17.3738V2.21143Z" fill="#FF5F00"/>
                  <path
                    d="M10.4415 8.49961C10.4415 6.04823 11.5634 3.73235 13.486 2.21149C10.0122 -0.519431 4.98342 0.0822808 2.2525 3.5561C-0.478415 7.02897 0.123296 12.0587 3.59711 14.7887C6.4986 17.0704 10.5845 17.0704 13.486 14.7887C11.5634 13.2678 10.4424 10.951 10.4415 8.50056V8.49961Z"
                    fill="#EB001B"/>
                  <path
                    d="M26.4402 8.49935C26.443 12.9132 22.8678 16.4931 18.455 16.4969C16.6621 16.4979 14.9205 15.8961 13.5105 14.7884C16.9834 12.0423 17.5728 7.00028 14.8257 3.52646C14.4401 3.03846 13.9985 2.59689 13.5105 2.21123C16.9805 -0.515902 22.0046 0.0858101 24.7317 3.55489C25.8394 4.96489 26.4421 6.70653 26.4402 8.49935Z"
                    fill="#F79E1B"/>
                  <g clip-path="url(#clip0_85_24294)">
                    <path
                      d="M32.541 1.9422C33.1246 1.64174 33.7919 1.76308 34.4189 1.75152C35.8547 1.78908 37.2934 1.71686 38.7292 1.78041C39.3763 1.77752 39.931 2.31488 40.0206 2.94178C40.4713 5.12585 40.8844 7.31859 41.3264 9.50844C40.5955 6.94302 38.6657 4.84851 36.3978 3.51669C35.1989 2.79734 33.8613 2.37843 32.541 1.9422Z"
                      fill="#F4A929"/>
                    <path
                      d="M45.0329 1.75732C46.278 1.77177 47.5203 1.76599 48.7625 1.75732C46.8731 6.2728 45.1109 10.8403 43.181 15.3384C41.9677 15.3009 40.7543 15.3182 39.5409 15.3182C38.4662 11.3921 37.4637 7.44573 36.3977 3.51671C38.6656 4.84853 40.5954 6.94304 41.3263 9.50846C41.4361 10.0054 41.5141 10.5138 41.6094 11.0165C42.7419 7.92819 43.8888 4.84276 45.0329 1.75732Z"
                      fill="#1B4DA2"/>
                    <path
                      d="M50.158 1.75146C51.328 1.76013 52.4981 1.76013 53.6681 1.75146C52.9487 6.27561 52.1918 10.794 51.4898 15.321C50.3255 15.321 49.1613 15.321 47.9941 15.321C48.6644 10.7911 49.4531 6.2785 50.158 1.75146Z"
                      fill="#1B4DA2"/>
                    <path
                      d="M56.9962 2.6034C59.0936 1.22536 61.8352 1.2658 64.155 2.02849C64.0482 3.03097 63.8806 4.02478 63.7073 5.0157C62.4737 4.42346 61.0349 4.16056 59.6945 4.50435C59.0618 4.65458 58.4378 5.44038 58.9636 6.02973C60.044 7.13621 61.7456 7.38755 62.7626 8.59226C63.9413 9.74496 63.8979 11.6864 63.0948 13.0355C62.2454 14.4598 60.6103 15.2051 59.0184 15.4189C57.2186 15.6067 55.3437 15.494 53.6565 14.7978C53.8356 13.7866 53.9858 12.7697 54.1678 11.7586C55.6268 12.5126 57.3197 12.8911 58.9462 12.5299C59.498 12.345 60.0671 11.8915 60.018 11.2443C59.836 10.473 59.03 10.1436 58.4031 9.79407C57.1868 9.19605 55.8781 8.46225 55.3321 7.14777C54.6532 5.4866 55.5517 3.54232 56.9962 2.6034Z"
                      fill="#1B4DA2"/>
                    <path
                      d="M68.5029 3.14099C68.7369 2.51697 69.1992 1.83806 69.9301 1.80051C71.0048 1.72539 72.0853 1.78895 73.16 1.76873C74.122 6.28709 75.0523 10.8083 75.9998 15.3267C74.9194 15.3267 73.8389 15.3267 72.7584 15.3325C72.6053 14.6536 72.4608 13.9718 72.3222 13.2871C70.8228 13.2871 69.3263 13.29 67.8298 13.2813C67.59 13.966 67.3416 14.6507 67.0845 15.3296C65.8595 15.3296 64.6346 15.3296 63.4097 15.3325C65.1026 11.2677 66.8129 7.20868 68.5029 3.14099Z"
                      fill="#1B4DA2"/>
                    <path
                      d="M68.8496 10.4903C69.5025 8.81183 70.037 7.08422 70.7679 5.4375C70.9846 7.142 71.4092 8.81183 71.7588 10.4932C70.7881 10.4932 69.8203 10.4932 68.8496 10.4903Z"
                      fill="white"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_85_24294">
                      <rect width="43.4589" height="14" fill="white" transform="translate(32.541 1.5)"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>

            <!-- Card Form -->
            <form>
              <div class="mb-3">
                <input type="text" class="form-control" placeholder="Card Number" maxlength="19">
              </div>

              <div class="mb-3">
                <input type="text" class="form-control" placeholder="Expiry Date" maxlength="5">
              </div>

              <div class="mb-3">
                <input type="text" class="form-control" placeholder="CVV" maxlength="3">
              </div>

              <div class="mb-3">
                <input type="text" class="form-control" placeholder="Name on the Card">
              </div>

              <!-- Scan Card Button -->
              <button type="button" class="btn scan-card-btn">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.125 13.2143C8.125 10.8654 10.082 8.96429 12.5 8.96429C14.918 8.96429 16.875 10.8654 16.875 13.2143C16.875 15.5632 14.918 17.4643 12.5 17.4643C10.082 17.4643 8.125 15.5632 8.125 13.2143ZM12.5 10.1786C10.7734 10.1786 9.375 11.5371 9.375 13.2143C9.375 14.8915 10.7734 16.25 12.5 16.25C14.2266 16.25 15.625 14.8915 15.625 13.2143C15.625 11.5371 14.2266 10.1786 12.5 10.1786ZM16.6758 4.7454L17.082 5.92857H20C21.3789 5.92857 22.5 7.01763 22.5 8.35714V18.0714C22.5 19.4109 21.3789 20.5 20 20.5H5C3.61914 20.5 2.5 19.4109 2.5 18.0714V8.35714C2.5 7.01763 3.61914 5.92857 5 5.92857H7.91797L8.32422 4.7454C8.57812 4.00165 9.29297 3.5 10.1016 3.5H14.8984C15.707 3.5 16.4219 4.00165 16.6758 4.7454ZM5 7.14286C4.30977 7.14286 3.75 7.68549 3.75 8.35714V18.0714C3.75 18.7431 4.30977 19.2857 5 19.2857H20C20.6914 19.2857 21.25 18.7431 21.25 18.0714V8.35714C21.25 7.68549 20.6914 7.14286 20 7.14286H16.1836L15.4922 5.12942C15.4062 4.88163 15.168 4.71429 14.8984 4.71429H10.1016C9.83203 4.71429 9.59375 4.88163 9.50781 5.12942L8.81641 7.14286H5Z"
                    fill="#3D45E0"/>
                </svg>
                Scan Your Card
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="config.orderReference.orderReference"
         class="d-flex justify-content-center align-items-center position-relative w-100">
      <!-- Image overlay - positioned absolutely over the second div -->
      <div *ngIf="employeeAnimationState === 'hidden'"
           class="position-absolute cursor-pointer"
           style="top: -7px; left: -1px; z-index: 10;"
           (click)="toggleEmployeeSection()">
        <img [@slideDown]
             [src]="config.salesPersonDetails.defaultSalesPersonImage ?? '/assets/img/sales-person-image.png'"
             class="rounded-circle profile-image"
             alt="Profile picture of Server">
      </div>

      <div *ngIf="config.orderReference.orderNumbers"
           class="table-number-container d-flex justify-content-between align-items-center position-relative">
        <div class="table-number d-flex align-items-center">
          <span class="hash-symbol">#</span>
          <span class="number-text">{{ order?.id }}</span>
        </div>

        <div *ngIf="order?.orderPosTableInfo[0]?.merchantSaleUnitId" class="table-label d-flex align-items-end mt-3">
          <span
            class="table-text mr-1 mt-1">{{ order?.orderPosTableInfo[0]?.merchantSaleUnit?.identifier ? 'Table' : 'Lane' }}</span>
          <span class="table-number-text">{{ order?.orderPosTableInfo[0]?.merchantSaleUnit?.identifier ?? '12' }}</span>
        </div>
      </div>
      <div *ngIf="config.orderReference.humanFriendlyOrderReference"
           class="human-friendly-order-reference d-flex justify-content-between align-items-center position-relative">

        <svg width="120" height="54" viewBox="0 0 120 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M104.661 4.77729C105.5 2.84133 107.039 0.796215 108.542 0C108.608 0.497634 107.593 4.13839 107.857 4.27323C108.084 4.39202 109.572 1.05306 109.92 0.927847C110.42 2.38543 110.044 6.63298 110.044 6.63298C112.798 8.48868 112.674 12.4698 114.801 14.7268C115.676 15.6546 121.508 20.4865 119.63 21.546L119.563 21.5941C114.055 25.1771 108.666 19.7673 103.031 22.9522C97.7746 26.0022 87.1319 32.1054 87.1319 32.1054C87.1319 35.82 88.3831 39.2682 89.1345 42.8511C89.3829 44.3087 89.3829 45.9011 89.7585 47.2271C90.3826 49.6157 91.1339 49.7474 92.888 50.8101C93.7635 51.3398 94.7663 51.0765 94.5149 52.5341C94.2634 53.7285 93.0122 53.8601 92.1367 53.9917C90.2584 54.1234 88.5073 52.6658 87.6288 51.0733C85.8777 48.0233 85.2506 44.3087 83.4965 41.1239C83.3723 40.8574 83.1209 40.4593 82.8694 40.196C82.8694 40.196 82.618 48.1549 77.8616 49.4809C76.4862 49.879 69.2245 51.205 71.9783 47.2271C73.6051 44.7068 78.3645 48.5531 78.8644 44.3087C79.1158 41.7884 76.7377 37.8074 76.1106 35.1555C75.9863 34.096 75.235 31.839 75.235 31.839C70.9786 33.4314 64.0925 29.0522 64.0925 29.0522C63.9682 32.7668 55.831 38.7384 55.831 38.7384C54.8282 41.522 59.0847 43.9106 60.3389 45.9011C60.966 46.829 62.3414 48.9512 62.4656 50.0138C62.714 52.5341 60.3389 51.2082 59.2119 50.0138C56.958 47.76 54.8312 44.7068 52.9529 42.1865C52.0774 40.9922 49.9476 39.0049 50.1991 37.2776C50.4505 35.6884 52.5773 34.7573 52.7015 32.9016C52.7015 32.9016 49.6962 35.5536 47.318 36.4814C45.0641 37.2776 43.4372 38.0738 42.186 40.4625C41.1833 42.453 40.5592 44.9733 40.9348 47.0955C41.4347 50.2771 44.3158 49.086 45.0671 51.4714C45.0671 51.4714 40.1835 52.2676 38.4325 48.553C37.1813 45.7663 37.5569 38.4687 37.5569 38.4687C39.8109 37.6725 41.9376 35.5504 42.3133 32.8984C42.6889 30.7763 41.1863 28.9174 41.3105 26.93C37.9296 28.3876 35.1757 31.4409 32.6733 34.2244C30.171 36.8763 27.2899 39.5314 24.0362 41.1239C18.6527 43.6441 12.0181 45.503 6.00753 44.7068C4.12923 44.5752 0 43.2492 0 43.2492C0.49987 42.0549 4.75634 40.3308 6.00753 39.5346C7.51017 38.6068 9.13702 37.8106 10.6397 36.7511C13.5177 34.6289 16.6502 32.2403 18.9012 29.3219C21.2793 26.1402 24.2846 23.7516 27.4141 21.2313C32.4219 17.2502 38.0538 11.9432 44.6884 11.2819C44.6884 11.2819 67.0977 8.36347 78.7402 9.9559C82.9967 10.4856 87.6288 10.6205 91.761 9.69263C93.8878 9.16289 95.8933 8.89642 97.8958 7.83694C99.8983 6.64261 104.128 5.22034 104.282 5.18503C104.434 5.1465 104.567 4.99561 104.658 4.78692L104.661 4.77729Z"
            fill="white"/>
        </svg>

        <div class="d-flex align-items-end flex-column">
          <span class="table-text mr-1 mt-1">Order Ref.</span>
          <span class="table-number-text mt-1">BLUE FOX</span>
          <div class="table-label mt-4">
            <span
              class="table-text mr-1">{{ order?.orderPosTableInfo[0]?.merchantSaleUnit?.identifier ? 'Table' : 'Lane' }}</span>
            <span class="table-number-text">{{ order?.orderPosTableInfo[0]?.merchantSaleUnit?.identifier ?? '12' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body border">

      <div class="d-flex flex-row justify-content-between">
        <div class="h4 font-weight-bold">Receipt</div>
        <div class="font-weight-light">No. {{ order?.compositeIdentifier }}</div>
      </div>

      <hr class="receipt-thin-separator mt-1 mb-2">
      <div *ngIf="config.itemisedPurchaseList">
        <div *ngFor="let orderItem of order?.orderItems;" class="row pt-1">
          <div *ngIf="config.itemisedPurchaseList.showQuantity" class="col-auto">{{ orderItem?.quantity }}</div>
          <div *ngIf="config.itemisedPurchaseList.showDescription" class="col">
            {{ orderItem?.product?.name }}
            <span class="text-muted"><br>{{ orderItem?.product?.priceTag }}</span>
            <div *ngFor="let orderItemModifier of orderItem?.orderItemModifiers;">
              <div class="d-flex flex-row justify-content-between text-secondary font-weight-light">
                <div class="col-auto text-left">{{ '- ' + orderItemModifier?.modifier?.name }}</div>
                <div class="col-sm-4 text-right mr-n3">
                  {{
                    orderItemModifier?.modifierPrice
                      ? order?.merchant?.currency?.symbol +
                      (orderItem?.quantity * orderItemModifier?.modifierPrice | number : '1.2-2')
                      : ''
                  }}
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="config.itemisedPurchaseList.showUnitPrice" class="col-auto">
            {{ order?.merchant?.currency?.symbol + (orderItem?.quantity * orderItem?.price | number : '1.2-2') }}
          </div>
        </div>
      </div>
      <div *ngIf="gcAmount" class="row pt-1">
        <div class="col-auto">{{ gcQty }}</div>
        <div class="col">Gift Card</div>
        <div class="col-auto">
          {{ order?.merchant?.currency?.symbol + (gcAmount | number : '1.2-2') }}
        </div>
      </div>

      <hr class="mt-3 receipt-thick-separator">

      <div *ngIf="config.itemisedPurchaseList.showSubtotalBeforeTax" class="mt-3 text-right">
        <div class="d-flex justify-content-between">
          <div>Subtotal</div>
          {{ order?.merchant?.currency?.symbol + (subTotal | number : '1.2-2') }}
        </div>
      </div>

      <div
        *ngIf="order?.discountAmount || order?.serviceChargeAmount || order?.deliveryFee || order?.processingFee || totalDrs || totalTipsAmount"
        class="text-right">
        <div class="mt-2 d-flex justify-content-between"
             *ngIf="config.itemisedPurchaseList.showDiscounts && order?.discountAmount">
          <div>Discount Amount</div>
          {{ order?.merchant?.currency?.symbol + (order?.discountAmount | number : '1.2-2') }}
        </div>
        <div class="mt-2 d-flex justify-content-between" *ngIf="order?.serviceChargeAmount">
          <div>Service Charge</div>
          {{ order?.merchant?.currency?.symbol + (order?.serviceChargeAmount | number : '1.2-2') }}
        </div>
        <div class="mt-2 d-flex justify-content-between" *ngIf="totalDrs">
          <div>Deposit Return Scheme</div>
          {{ order?.merchant?.currency?.symbol + (totalDrs | number : '1.2-2') }}
        </div>
        <div class="mt-2 d-flex justify-content-between" *ngIf="order?.deliveryFee">
          <div>Delivery Fee</div>
          {{ order?.merchant?.currency?.symbol + (order?.deliveryFee | number : '1.2-2') }}
        </div>
        <div class="mt-2 d-flex justify-content-between" *ngIf="order?.processingFee">
          <div>Service Fee</div>
          {{ order?.merchant?.currency?.symbol + (order?.processingFee | number : '1.2-2') }}
        </div>
        <div class="mt-2 d-flex justify-content-between" *ngIf="totalTipsAmount">
          <div>Tips</div>
          {{ order?.merchant?.currency?.symbol + (totalTipsAmount | number : '1.2-2') }}
        </div>
        <hr class="receipt-thin-separator">
      </div>

      <div *ngIf="!vatRatesMap" class="mt-2 text-right">
        <div class="d-flex justify-content-between" *ngIf="config.itemisedPurchaseList.showTaxesWithRate">
          <div>Sales Tax ({{ salesTaxPercent }}%)</div>
          {{ order?.merchant?.currency?.symbol + (getSalesTaxValue() | number : '1.2-2') }}
        </div>
      </div>

      <div class="mt-2 text-right" *ngIf="config.itemisedPurchaseList.showFinalAmountPayable">
        <div class="font-weight-bold d-flex justify-content-between">
          <div>Total</div>
          {{ order?.merchant?.currency?.symbol + ((order?.totalPrice ?? total) + (totalTipsAmount || 0) | number : '1.2-2') }}
        </div>
      </div>

      <div *ngFor="let vatRate of vatRatesMap | keyvalue;" class="mt-2 text-right font-weight-light">
        <div class="d-flex justify-content-between">
          <div>VAT ({{ vatRate?.key }})</div>
          {{ order?.merchant?.currency?.symbol + (vatRate?.value | number : '1.2-2') }}
        </div>
      </div>

      <div *ngIf="orderLink === 'mo0d2fyiay'; else standardPayments">
        <div *ngIf="config.paymentMethod.showPaymentMethod" class="text-small font-weight-light mt-3">
          <div *ngFor="let i of getArray(splitPayments)" class="d-flex justify-content-between">
          <span class="text-start">
            {{ getRandomCardNumbers(config.paymentMethod.showLast4Card) }}</span>
            <span class="text-end">
            {{ order?.merchant?.currency?.symbol + (total / splitPayments + (splitPayments > 1 ? 0.25 : 0) | number : '1.2-2') }}</span>
          </div>
        </div>
      </div>

      <ng-template #standardPayments>
        <div *ngIf="order?.orderPayments?.length && config.paymentMethod.showPaymentMethod" class="text-small font-weight-light mt-3">
          <div *ngFor="let payment of order.orderPayments" class="d-flex justify-content-between">
            <span class="text-start">{{ getPaymentDisplayText(config.paymentMethod.showLast4Card, payment) }}</span>
            <span class="text-end">{{ order?.merchant?.currency?.symbol + (payment.settledAmount + payment.tipsAmount | number : '1.2-2') }}</span>
          </div>
        </div>
      </ng-template>

      <div class="text-small font-weight-light">
        <div class="mt-3 d-flex">
          <div>
            <span
              *ngIf="config.transactionDetails.showDateOfPurchase">{{ order?.createdDate ?? currentDate | date:"dd MMM yyyy" }}</span>
            <span
              *ngIf="config.transactionDetails.showDateOfPurchase && config.transactionDetails.showTimeOfPurchase">, </span>
            <span
              *ngIf="config.transactionDetails.showTimeOfPurchase">{{ order?.createdDate ?? currentDate | date:"HH:mm" }}</span>
          </div>
          <div *ngIf="config.transactionDetails.showTransactionSource" class="ml-4">{{ order?.applicationSource?.name }}
          </div>
        </div>

        <hr class="receipt-thin-separator my-2">

        <div>
          <div *ngIf="config.businessDetails.showBusinessName">{{ order?.merchant?.name }}</div>
          <div *ngIf="config.businessDetails.showBusinessAddress">{{ order?.merchant?.address }}</div>
          <div *ngIf="config.businessDetails.showTaxIdVat && order?.merchant?.vatNumber">VAT
            No: {{ order?.merchant?.vatNumber }}
          </div>
        </div>

        <hr class="receipt-thin-separator my-2">

        <div class="d-flex justify-content-between">
          <div *ngIf="config.transactionDetails.showTransactionNumber">Transaction No. 200145</div>
          <div *ngIf="order?.orderPayments?.length && order.orderPayments[0]?.data?.entryMode">Entry Mode: {{ order?.orderPayments[0]?.data?.entryMode }}</div>
          <div *ngIf="config.transactionDetails.showMerchantId || order?.orderPayments?.length && order.orderPayments[0]?.data?.isAibPayment" class="ml-auto">
            MID: ****{{
              order?.orderPayments[0]?.data?.merchantId
                ? (order.orderPayments[0].data.merchantId | slice:-4)
                : '9110'
            }}
          </div>
        </div>

        <div class="d-flex justify-content-between">
          <div *ngIf="config.showSalesPersonNameId">Sales Assistant: 607 Aisling B.</div>
          <div *ngIf="order?.orderPayments?.length && order.orderPayments[0]?.data?.aId">AID: {{ order?.orderPayments[0]?.data?.aId }}</div>
          <div *ngIf="config.transactionDetails.showTerminalId || (order?.orderPayments?.length && order.orderPayments[0]?.data?.isAibPayment)" class="ml-auto">
            TID: ****{{
              order?.orderPayments[0]?.data?.terminalId
                ? (order.orderPayments[0].data.terminalId | slice:-4)
                : '9988'
            }}</div>
        </div>

        <div class="d-flex justify-content-between">
          <div *ngIf="order?.orderPayments?.length && order.orderPayments[0]?.data?.uniqueRef">
            Unique Ref: {{ order?.orderPayments[0]?.data?.uniqueRef }}</div>
          <div *ngIf="order?.orderPayments?.length && order.orderPayments[0]?.data?.authCode">
            Auth Code: {{ order?.orderPayments[0]?.data?.authCode }}</div>
        </div>

        <div *ngIf="order?.orderPayments?.length && order.orderPayments[0]?.data?.dccRate">
          <div>
            Transaction Amount: {{ getCurrencySymbol(order.orderPayments[0].data.dccCurrency) }} {{ order.orderPayments[0].data.dccAmount }}
          </div>
          <div>
            Exchange Rate: 1 EUR = {{ order.orderPayments[0].data.dccRate }} {{ getCurrencySymbol(order.orderPayments[0].data.dccCurrency) }}
          </div>
          <div>
              Margin: {{ order.orderPayments[0].data.dccMarkup }}%
          </div>
          <div class="text-muted small mt-2">
            {{ order.orderPayments[0].data.dccDisclaimer }}
          </div>
        </div>

      </div>
      <div *ngIf="config.transactionDetails.showReceiptNumber" class="d-flex justify-content-center mb-2">
        <ngx-barcode6 [bc-display-value]="'true'" [bc-value]="order?.compositeIdentifier" [bc-height]="50"></ngx-barcode6>
      </div>

      <div class="text-center mt-2" data-html2canvas-ignore="true">

        <div *ngIf="getDeviceType() === 'other'; else addToWallet" class="d-flex">
          <a style="color:#000;text-decoration: none;font-weight: 600; display: inline-block;" [href]="appleWalletLink">
            <img width="300" alt=""
                 src="https://upcofile.s3.eu-west-1.amazonaws.com/webgiftcard-assets/add-to-apple-wallet-logo.png">
          </a>

          <div class="btn scan-card-btn cursor-pointer d-flex align-items-center justify-content-center ml-2"
               (click)="toggleDownloadSection()">
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.6786 5H13.25C12.9161 5 12.6429 5.28125 12.6429 5.625C12.6429 5.96875 12.9161 6.25 13.25 6.25H15.6786C16.0125 6.25 16.2857 6.53125 16.2857 6.875V18.125C16.2857 18.4692 16.013 18.75 15.6786 18.75H2.32143C1.98712 18.75 1.71429 18.4688 1.71429 18.125V6.875C1.71429 6.53125 1.98712 6.25 2.32143 6.25H4.75C5.08393 6.25 5.35714 5.96875 5.35714 5.625C5.35714 5.28125 5.08393 5 4.75 5H2.32143C1.31699 5 0.5 5.83984 0.5 6.875V18.125C0.5 19.1602 1.31699 20 2.32143 20H15.6786C16.683 20 17.5 19.159 17.5 18.125V6.875C17.5 5.83984 16.6842 5 15.6786 5ZM4.92835 10.1836C4.69118 10.4277 4.69118 10.8234 4.92835 11.0672L8.57121 14.8172C8.68884 14.9375 8.84442 15 9 15C9.15558 15 9.31071 14.939 9.42917 14.8169L13.072 11.0669C13.3092 10.8227 13.3092 10.427 13.072 10.1833C12.8349 9.93953 12.4505 9.93914 12.2137 10.1833L9.60714 12.8672V0.625C9.60714 0.279531 9.33393 0 9 0C8.66607 0 8.39286 0.279531 8.39286 0.625V12.8672L5.78594 10.1836C5.55067 9.9375 5.16362 9.9375 4.92835 10.1836Z"
                fill="#3D45E0"/>
            </svg>
          </div>
        </div>

        <ng-template #addToWallet>
          <div class="d-flex">
            <a *ngIf="getDeviceType() === 'android'"
               style="color:#000;text-decoration: none;font-weight: 600; display: inline-block;" [href]="googleWalletLink">
              <img width="300" alt=""
                   src="https://upcofile.s3.eu-west-1.amazonaws.com/webgiftcard-assets/add-to-google-wallet-logo.png">
            </a>

            <a *ngIf="getDeviceType() === 'ios'"
               style="color:#000;text-decoration: none;font-weight: 600; display: inline-block;" [href]="appleWalletLink">
              <img width="300" alt=""
                   src="https://upcofile.s3.eu-west-1.amazonaws.com/webgiftcard-assets/add-to-apple-wallet-logo.png">
            </a>

            <div class="btn scan-card-btn cursor-pointer d-flex align-items-center justify-content-center ml-2"
                 (click)="toggleDownloadSection()">
              <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.6786 5H13.25C12.9161 5 12.6429 5.28125 12.6429 5.625C12.6429 5.96875 12.9161 6.25 13.25 6.25H15.6786C16.0125 6.25 16.2857 6.53125 16.2857 6.875V18.125C16.2857 18.4692 16.013 18.75 15.6786 18.75H2.32143C1.98712 18.75 1.71429 18.4688 1.71429 18.125V6.875C1.71429 6.53125 1.98712 6.25 2.32143 6.25H4.75C5.08393 6.25 5.35714 5.96875 5.35714 5.625C5.35714 5.28125 5.08393 5 4.75 5H2.32143C1.31699 5 0.5 5.83984 0.5 6.875V18.125C0.5 19.1602 1.31699 20 2.32143 20H15.6786C16.683 20 17.5 19.159 17.5 18.125V6.875C17.5 5.83984 16.6842 5 15.6786 5ZM4.92835 10.1836C4.69118 10.4277 4.69118 10.8234 4.92835 11.0672L8.57121 14.8172C8.68884 14.9375 8.84442 15 9 15C9.15558 15 9.31071 14.939 9.42917 14.8169L13.072 11.0669C13.3092 10.8227 13.3092 10.427 13.072 10.1833C12.8349 9.93953 12.4505 9.93914 12.2137 10.1833L9.60714 12.8672V0.625C9.60714 0.279531 9.33393 0 9 0C8.66607 0 8.39286 0.279531 8.39286 0.625V12.8672L5.78594 10.1836C5.55067 9.9375 5.16362 9.9375 4.92835 10.1836Z"
                  fill="#3D45E0"/>
              </svg>
            </div>
          </div>
        </ng-template>
      </div>

      <div *ngIf="shouldSaveReceipt" class="rounded-top shadow-top" data-html2canvas-ignore="true">
        <div class="modal-backdrop fade show"
             (click)="toggleDownloadSection()"
             style="z-index: 1040;">
        </div>

        <!-- Notification panel -->
        <div class="notification-panel" [@slideDown]>

          <div class="d-flex justify-content-end p-3 border-bottom text-right">
            <button class="close" (click)="toggleDownloadSection()" style="outline: none;">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Save receipt section -->
          <div class="p-3 border-bottom">
            <a class="btn btn-link text-purple p-0 d-flex align-items-center font-weight-normal" (click)="saveAsPDF()">
              <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.6786 5H13.25C12.9161 5 12.6429 5.28125 12.6429 5.625C12.6429 5.96875 12.9161 6.25 13.25 6.25H15.6786C16.0125 6.25 16.2857 6.53125 16.2857 6.875V18.125C16.2857 18.4692 16.013 18.75 15.6786 18.75H2.32143C1.98712 18.75 1.71429 18.4688 1.71429 18.125V6.875C1.71429 6.53125 1.98712 6.25 2.32143 6.25H4.75C5.08393 6.25 5.35714 5.96875 5.35714 5.625C5.35714 5.28125 5.08393 5 4.75 5H2.32143C1.31699 5 0.5 5.83984 0.5 6.875V18.125C0.5 19.1602 1.31699 20 2.32143 20H15.6786C16.683 20 17.5 19.159 17.5 18.125V6.875C17.5 5.83984 16.6842 5 15.6786 5ZM4.92835 10.1836C4.69118 10.4277 4.69118 10.8234 4.92835 11.0672L8.57121 14.8172C8.68884 14.9375 8.84442 15 9 15C9.15558 15 9.31071 14.939 9.42917 14.8169L13.072 11.0669C13.3092 10.8227 13.3092 10.427 13.072 10.1833C12.8349 9.93953 12.4505 9.93914 12.2137 10.1833L9.60714 12.8672V0.625C9.60714 0.279531 9.33393 0 9 0C8.66607 0 8.39286 0.279531 8.39286 0.625V12.8672L5.78594 10.1836C5.55067 9.9375 5.16362 9.9375 4.92835 10.1836Z"
                  fill="#3D45E0"/>
              </svg>
              <span class="ml-2 pt-1">Save receipt</span>
            </a>
          </div>

          <div class="p-3 pb-5" *ngIf="!sendReceipt">
            <a class="btn btn-link text-purple p-0 d-flex align-items-center font-weight-normal"
               (click)="sendReceipt = true">
              <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 3C0 1.61914 1.11914 0.5 2.5 0.5H17.5C18.8789 0.5 20 1.61914 20 3V13C20 14.3789 18.8789 15.5 17.5 15.5H2.5C1.11914 15.5 0 14.3789 0 13V3ZM1.25 3V4.55859L8.89062 10.1602C9.55078 10.6445 10.4492 10.6445 11.1094 10.1602L18.75 4.55859V3C18.75 2.30859 18.1914 1.75 17.5 1.75H2.46484C1.80977 1.75 1.21484 2.30859 1.21484 3H1.25ZM1.25 6.10938V13C1.25 13.6914 1.80977 14.25 2.5 14.25H17.5C18.1914 14.25 18.75 13.6914 18.75 13V6.10938L11.8477 11.168C10.7461 11.9766 9.25391 11.9766 8.15234 11.168L1.25 6.10938Z"
                  fill="#3D45E0"/>
              </svg>
              <span class="ml-2">Email receipt to myself</span>
            </a>
          </div>

          <!-- Email receipt section -->
          <div class="p-3 pb-5" *ngIf="sendReceipt">
            <h6 class="mb-3">Email receipt to myself</h6>
            <div>
              <div class="form-group mt-3">
                <input type="email" [(ngModel)]="emailAddress" placeholder="Email" required
                       class="form-control">
              </div>

              <div class="text-center mt-3">
                <button class="btn btn-dark dark-button w-100"
                        [disabled]="!emailAddress || !emailAddress.match(emailRegex) || isSendingEmail"
                        (click)="sendEmail()">
                  <span *ngIf="!isSendingEmail">Send</span>
                  <span *ngIf="isSendingEmail">Sending...</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="config.customerEngagement.downloadApp"
         class="d-flex justify-content-center align-items-center flex-column mb-2 mt-3">
      <img class="img-fluid w-30" src="/assets/img/app-BuyNLarge.png"/>
      <h5 class="font-weight-bold mt-3">Download our App</h5>
      <p class="text-small text-muted text-center py-1" style="max-width: 174px;">Get exclusive deals and track your
        orders anytime</p>
      <button (click)="downloadApp()"
              class="btn btn-dark dark-button d-flex align-items-center justify-content-center mb-3 px-5">Download App
      </button>
    </div>

    <div *ngIf="config.customerEngagement.giftCardUpsell" class="my-3 d-flex justify-content-center">
      <a [href]="giftCardUrl" target="_blank"
         class="cursor-pointer">
        <img [@slideDown]
             src="/assets/img/buy-gift-card.png"
             alt="BUY GIFT CARD">
      </a>
    </div>

    <div *ngIf="config.customerEngagement.loyaltyProgramme" class="my-3 d-flex justify-content-center">
      <a href="https://www.walmart.com/plus/partnerenroll?programName=sparkpromo21&programId=sparkpromo21" target="_blank"
         class="cursor-pointer">
        <img [@slideDown]
             src="/assets/img/join-loyalty.png"
             alt="JOIN LOYALTY">
      </a>
    </div>

    <div *ngIf="config.donation.donation" class="my-3 d-flex justify-content-center">
      <a href="https://www.cancer.org/donate.html" target="_blank"
         class="cursor-pointer">
        <img [@slideDown]
             src="/assets/img/donate.png"
             alt="DONATE">
      </a>
    </div>

    <div class="container-fluid bg-light py-4">

      <app-feedback-section [merchantId]="order?.merchant?.id" [config]="config.leaveReview"></app-feedback-section>

      <div *ngIf="config.merchantFooter">
        <div class="d-flex justify-content-center align-items-center flex-column my-3 fs-11">
          <div *ngIf="config.merchantFooterDetails.showMerchantLogo" class="receipt-img d-flex justify-content-center">
            <img *ngIf="merchantLink === '3q60r9bpsg'; else brandImage" class="img-fluid w-30"
                 src="{{ order?.merchant?.imageURL }}"/>
            <ng-template #brandImage>
              <img class="img-fluid w-30 mt-2 mb-4" src="{{ order?.merchant?.brand?.photoURL }}"/>
            </ng-template>
          </div>
          <span *ngIf="config.merchantFooterDetails.showMerchantName">© {{ currentDate | date:'yyyy' }}, {{ order?.merchant?.name }}</span>
          <span *ngIf="config.merchantFooterDetails.showMerchantAddress">{{ order?.merchant?.address }}</span>
          <span>
              <span
                *ngIf="config.merchantFooterDetails.showMerchantContactPhone && order?.merchant?.phoneNumber">T: {{ order?.merchant?.phoneNumber }}</span>
              <span
                *ngIf="config.merchantFooterDetails.showMerchantContactPhone && config.merchantFooterDetails.showMerchantContactEmail && order?.merchant?.phoneNumber && order?.merchant?.contactEmail"> | </span>
              <span
                *ngIf="config.merchantFooterDetails.showMerchantContactEmail && order?.merchant?.contactEmail">E: {{ order?.merchant?.contactEmail }}</span>
            </span>
        </div>

        <div *ngIf="config.merchantFooterDetails.showMerchantSocialMediaLinks" class="row justify-content-center">
          <div class="col-auto">
            <div class="d-flex gap-3">
              <a *ngFor="let socialLink of order?.merchant?.merchantSocialLinks"
                 [href]="socialLink.link"
                 target="_blank"
                 rel="noopener noreferrer"
                 class="text-decoration-none"
                 [attr.aria-label]="socialLink.name">
                <div class="bg-black rounded-circle d-flex align-items-center justify-content-center"
                     style="width: 48px; height: 48px;">
                  <fa-icon [icon]="getSocialIcon(socialLink.name)"
                           class="text-white"
                           size="lg">
                  </fa-icon>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row align-items-center receipt-footer">
      <div class="col-7">
        <div class="ml-3 mb-1 text-white small">Powered by</div>
        <img class="col-12" src="/assets/img/f-logo.svg"/>
      </div>
      <div class="col-5 d-flex justify-content-end pr-4">
        <a href="https://supersweet.ai/" class="arrow-link text-white" target="_blank">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="white" stroke-opacity="0.2"/>
            <path
              d="M25.8115 15.7929L33.668 23.2305C33.88 23.4311 34 23.7091 34 23.9999C34 24.2908 33.88 24.5684 33.668 24.7694L25.8115 32.2069C25.3832 32.6109 24.7053 32.5957 24.2964 32.171C23.8877 31.7504 23.9031 31.0752 24.3327 30.6684L30.2563 25.0637H15.0718C14.4803 25.0637 14 24.5873 14 24.0007C14 23.4141 14.4803 22.9386 15.0718 22.9386H30.2535L24.3299 17.3339C23.9009 16.9263 23.8876 16.2511 24.2938 15.8292C24.7044 15.4042 25.3428 15.3892 25.8115 15.7929Z"
              fill="white"/>
          </svg>
        </a>
      </div>
    </div>
    <img class="mh-12" src="/assets/img/supersweet-ribbon.png"/>
  </div>
  </ng-template>
</ng-container>